// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaA = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M8.73 16.645H7.092v-.49l3.57-9.562h2.646l3.528 9.562v.49H15.1l-1.008-2.87H9.738zm2.715-7.681c-.147.424-.328.946-.6 1.717l-.575 1.596h3.318l-.546-1.596c-.434-1.246-.672-1.96-.868-2.562h-.434c-.095.268-.186.53-.295.845"
    />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaA;
